import React, { useEffect, useContext, useState } from 'react';

import { notification, Badge } from 'antd';

import styled from 'styled-components';

import { saveAlerts } from '@libs/NwAlerts';
import { getMoment } from '@libs/NwMoment';
import { getNow, showLogNoTime } from '@libs/NwMoment';

import { ListContext } from '@contexts/ListContext';
import { useStateValue } from '@contexts/StateProvider';
import { UserContext } from '@contexts/UserContext';

import { useContact } from '@hooks/API/Contact/UseContact';
import useLocalStorageState from '@hooks/Utils/UseLocalStorageState';

import NwDropDownMenu from '@components/Gui/NwDropDownMenu';
import NwIcon from '@components/Gui/NwIcon';
import StyleVariables from '@components/Gui/StyleVariables.js';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const BadgeRibbon = styled(Badge.Ribbon)`
    z-index: 6;

    height: ${(props) => props.size === 'small' && '16px'};
    font-size: ${(props) => props.size === 'small' && '12px'};

    .ribbon-content {
        line-height: ${(props) => props.size === 'small' && '18px'};
    }
`;

const ContactAlert = ({ currentContact, icon, readOnly, size, children }) => {
    const { GetUserName } = useContext(ListContext);
    const [{ areaContext }] = useStateValue();
    const [readAlerts, setReadAlerts] = useLocalStorageState(`${areaContext.area}-read-alerts`, []);
    const { currentUser } = useContext(UserContext);
    const [alertVisible, setAlertVisible] = useState(false);

    useEffect(() => {
        return function cleanup() {
            notification.destroy();
        };
    }, []);

    const checkReadAlert = () => {
        return readAlerts.some((alert) => {
            return (
                alert.Author === currentUser.UserID &&
                alert.ContactID === currentContact.ID &&
                getMoment(alert.ExpirationDate) >= getNow() &&
                getMoment(currentContact.AlertCreationDate) <= getMoment(alert.Date)
            );
        });
    };

    useEffect(() => {
        //console.error("entrato useEffect contactalert")
        if (currentContact && !readOnly) {
            //console.error("currentContact e !readOnly")
            if (currentContact.Alert) {
                //console.error("il contatto (" + currentContact.ID    + ") ha un alert: ", currentContact.AlertMessage)
                if (!checkReadAlert()) {
                    //console.error("l'alert non è stato letto")
                    if (!alertVisible) {
                        //console.error("l'alert non è visibile quindi lo attivo")
                        handleDisplayNotification();
                        setAlertVisible(true);
                    }
                } else {
                    //console.error("l'alert è stato letto")
                    //     notification.destroy();
                }
            } else {
                //console.error("il contatto non ha un alert")
                //     notification.destroy();
            }
        }
    }, [currentContact, readOnly, readAlerts]);

    const handleAlerts = (alerts) => {
        setReadAlerts(alerts);
        saveAlerts(areaContext.area, alerts);
    };

    const handleDismissNotification = (key, period) => {
        notification.close(key);
        setAlertVisible(false);
        const findIndex = readAlerts.findIndex((alert) => {
            if (alert.Author === currentUser.UserID && alert.ContactID === currentContact.ID) {
                return true;
            }
            return false;
        });
        if (findIndex < 0) {
            handleAlerts([
                ...readAlerts,
                {
                    Author: currentUser.UserID,
                    ContactID: currentContact.ID,
                    Date: getNow(),
                    ExpirationDate: period === 'day' ? getNow().endOf('day') : getNow().add(1, period),
                },
            ]);
        } else {
            const updatedReadAlerts = [...readAlerts];
            updatedReadAlerts[findIndex] = {
                ...updatedReadAlerts[findIndex],
                Date: getNow(),
                ExpirationDate: period === 'day' ? getNow().endOf('day') : getNow().add(1, period),
            };
            handleAlerts(updatedReadAlerts);
        }
    };

    const getActions = (key) => {
        const actions = [
            {
                name: 'Mute for 7 days',
                key: 'week',
                pinned: true,
                action: () => {
                    handleDismissNotification(key, 'week');
                },
            },
            {
                name: 'Mute for today',
                type: 'day',
                key: 'day',
                action: () => {
                    handleDismissNotification(key, 'day');
                },
            },
            {
                name: 'Mute for 30 days',
                type: 'month',
                key: 'month',
                action: () => {
                    handleDismissNotification(key, 'month');
                },
            },
        ];

        return actions;
    };

    const handleDisplayNotification = () => {
        const key = `open${Date.now()}`;
        notification.warning({
            className: 'nw-notification-contact-alert',
            icon: <NwIcon icon={byPrefixAndName.fass['message-exclamation']} />,
            message: `${GetUserName(currentContact.AlertUser)} ${showLogNoTime(currentContact.AlertCreationDate)}`,
            description: (
                <>
                    <p>{currentContact.AlertMessage}</p>
                    <small></small>
                </>
            ),
            duration: 0,
            key,
            btn: <NwDropDownMenu actions={getActions(key)} />,
            onClose: () => {
                notification.close(key);
                setAlertVisible(false);
            },
            onClick: () => {
                //console.error("Notification Clicked!");
            },
        });
    };

    return !currentContact ? (
        <div />
    ) : currentContact.Alert ? (
        <>
            {icon ? (
                <div onClick={handleDisplayNotification}>{icon}</div>
            ) : (
                <BadgeRibbon
                    size={size}
                    color={StyleVariables.DangerColor}
                    text={
                        <div className="ribbon-content" onClick={handleDisplayNotification}>
                            <NwIcon icon={byPrefixAndName.fass['exclamation-circle']} /> Alert
                        </div>
                    }
                    placement="start"
                >
                    {children}
                </BadgeRibbon>
            )}
        </>
    ) : (
        <>{children}</>
    );
};

export default ContactAlert;
